import NextImage from '@/shared/components/atoms/NextImage';
import { getCountryIcon } from '@/shared/lib/country-flags';

interface IFlagComponentProps {
  country: string;
  countryName: string;
}

const FlagComponent: React.FC<IFlagComponentProps> = ({
  country,
  countryName,
}) => {
  return (
    <NextImage
      alt={countryName}
      src={getCountryIcon(country, '1x1')}
      width={24}
      height={24}
      className='h-24 w-24 rounded-full'
      imgClassName='rounded-full'
    />
  );
};

export default FlagComponent;
